module.exports = __webpack_public_path__ + "src/assets/images/logo_hero_color.png?d7d089d5363ce6cd1f7874ebb9a3beb4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_hero_color.png
// module id = 1020
// module chunks = 1